export default __webpack_public_path__ + "static/cards-min-cf50c1fc2a699239588e8c8dc9d0536a.png";